module.exports = __webpack_public_path__ + "static/media/launchpool.27122ceb.png";